import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import api from '../../../services/api';
import { useDispatch, useSelector } from 'react-redux';
import { setOpenProgress } from '../../../redux/openProgress';

import Table from '../../../components/Table';
import { FabButton } from 'components';
import * as Yup from 'yup';
import Success from '../../../components/Snack/Success';
import Error from '../../../components/Snack/Error';
import { setDisable } from '../../../redux/disable';
import { setLoading } from '../../../redux/loading';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@mui/material';

import './style.css';
import MaskedInput from 'react-text-mask';

function ListProperties() {
  const [properties, setProperties] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [open, setOpen] = useState(false);
  const openProgress = useSelector((state) => state.openProgress.openProgress);
  const dispatch = useDispatch();
  const error = Error();
  const success = Success();

  const columns = [
    {
      title: 'Nome da fazenda',
      field: 'name',
      hideFilterIcon: true,
    },
    {
      title: 'CPF/CNPJ',
      field: 'cnpj',
      hideFilterIcon: true,
      render: (rowData) => (
        <MaskedInput
          value={rowData.cnpj}
          className="maskStyle"
          disabled="true"
          mask={[
            /\d/,
            /\d/,
            '.',
            /\d/,
            /\d/,
            /\d/,
            '.',
            /\d/,
            /\d/,
            /\d/,
            '/',
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            '-',
            /\d/,
            /\d/,
          ]}
          showMask
        />
      ),
    },
  ];

  useEffect(() => {
    async function loadData() {
      try {
        const response = await api.get('/properties');

        if (response.data.length === 0) {
          dispatch(setOpenProgress(true));
        }
        if (response.data) {
          const data = await response.data;
          const organizedData = await data.map((_element) => ({
            name: _element.name,
            cnpj: _element.cnpj,
          }));
          setProperties(data);
          setExportData(organizedData);
          dispatch(setOpenProgress(true));
        }
      } catch (err) {}
    }
    loadData();
  }, [dispatch]);

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required('Campo obrigatório'),
    }),
    onSubmit: (values) => {
      dispatch(setDisable(true));
      dispatch(setLoading(true));

      request(values);
    },
  });

  async function request(data) {
    // envia os dados para api salvar no banco
    try {
      await api.post('/users/invite', data);
      success();
    } catch (err) {
      error();
    }
    dispatch(setDisable(false));
    formik.setFieldValue('email', '');
    dispatch(setLoading(false));
  }

  function setData(newData) {
    const tempData = [];
    properties.map((propriety) => (propriety.id === newData.id
      ? tempData.push(newData)
      : tempData.push(propriety)));
    setProperties(tempData);
  }
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Enviar Convite</DialogTitle>
        <form onSubmit={formik.handleSubmit}>
          <DialogContent>
            <DialogContentText>
              Para enviar o convite para o cliente, por favor coloque o email
              dele logo a baixo.
            </DialogContentText>

            <TextField
              autoFocus
              margin="dense"
              id="email"
              label="Endereço de Email"
              type="email"
              value={formik.values.email}
              onChange={(e) => {
                formik.setFieldValue('email', e.target.value);
              }}
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancelar
            </Button>
            <Button onClick={handleClose} color="primary" type="submit">
              Enviar
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <Table
        title="Fazendas"
        route="/admin/properties/"
        routeAdd="/admin/propertyChoose/"
        columns={columns}
        data={properties}
        setData={setData}
        dataLoaded={openProgress}
        fab={<FabButton onClick={() => setOpen(true)} />}
        exportData={exportData}
      />
    </>
  );
}

export default ListProperties;
